export default "__VITE_ASSET__DWXkkXDn__"